<rotec-form-v2
  [form]="stepForm"
  (formChange)="stepForm = $event"
  [fields]="descriptionFields"
  [options]="descriptionFormOptions"
  [model]="machineTaskModel"
  (modelChange)="machineTaskModelChange.emit($event)"
>
</rotec-form-v2>

<ng-template #durationMinutesLabel>
  <span>&nbsp; [</span>
  <div class="duration-minutes-label-dropdown">
    <div class="duration-minutes-label-label" #unitLabel (click)="toggleUnitSelect()">
      {{ durationUnit }}
    </div>
    <rotec-select-v2
      #actionSelect
      [items]="durationUnits"
      [customInputElement]="unitLabel"
      (selectedItemChange)="$event.value !== durationUnit && changeDurationUnit($event)"
    ></rotec-select-v2>
  </div>
  <span>]</span>
</ng-template>
